/* Diagnostic only. No accepted-signup/vote/DOI/purchase event or GA4 publisher. */
(() => {
  'use strict';
  const roots = document.querySelectorAll('[data-mok-waitlist-thanks]');
  if (!roots.length) return;
  const state = window.__mokWaitlistThanksPageState || { status: 'unseen' };
  window.__mokWaitlistThanksPageState = state;

  function explicitAnalyticsConsent() {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      return Boolean(privacy &&
        typeof privacy.analyticsProcessingAllowed === 'function' &&
        typeof privacy.currentVisitorConsent === 'function' &&
        privacy.analyticsProcessingAllowed() === true &&
        privacy.currentVisitorConsent().analytics === 'yes');
    } catch (_) { return false; }
  }

  function attemptDiagnostic() {
    if (!explicitAnalyticsConsent()) return;
    const bus = window.Shopify && window.Shopify.analytics;
    if (!bus || typeof bus.publish !== 'function') return;
    if (state.status !== 'unseen' ||
        !Array.from(roots).some(root => root.dataset.formId === 'MOK-WAITLIST-V1')) return;
    state.status = 'pending';
    try {
      Promise.resolve(bus.publish('mok_waitlist_thank_you_view', {
        form_id: 'MOK-WAITLIST-V1'
      })).then(result => {
        state.status = result === false ? 'unseen' : 'shopify_bus_dispatched_destination_unverified';
      }).catch(() => { state.status = 'unseen'; });
    } catch (_) { state.status = 'unseen'; }
  }

  document.addEventListener('visitorConsentCollected', attemptDiagnostic);
  attemptDiagnostic();
  if (!window.Shopify || window.Shopify.customerPrivacy ||
      typeof window.Shopify.loadFeatures !== 'function') return;
  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
    if (!error) attemptDiagnostic();
  });
})();
